import {
    Card,
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@repo/shadcn';
import { ColumnDef } from '@tanstack/react-table';

import { DataTable } from '@components/ui/data.table/data-table';
import PaginationComponent from '@components/ui/pagination';

import { DEFAULT_PAGE_LIMIT } from '@/constants';
import { useUrlPagination } from '@/hooks';
import { TPaginationResponse } from '@/shared/global.schema';

type SectionDataTableProps = {
    data?: {
        data: Array<any>;
        pagination: TPaginationResponse;
    };
    columns: ColumnDef<any>[];
    isLoading?: boolean;
};

export const SectionDataTable = ({
    data,
    columns,
    isLoading,
}: SectionDataTableProps) => {
    const { page, setCurrentPage } = useUrlPagination();

    return (
        <Card>
            <DataTable
                columns={columns}
                data={data?.data || []}
                isLoading={isLoading}
            />
            <div className="mt-3 flex items-center justify-between">
                <p className="flex w-full items-center px-4 text-right font-semibold">
                    Total: {data?.pagination?.total_items}
                </p>
                <div className="pr-4">
                    <LimitSelector />
                </div>
            </div>
            <PaginationComponent
                showTotalItems
                totalItems={data?.pagination?.total_items || 0}
                itemsPerPage={data?.pagination?.limit || DEFAULT_PAGE_LIMIT}
                initialPage={page}
                onPageChange={(p) => {
                    setCurrentPage(p);
                }}
            />
        </Card>
    );
};

export const LimitSelector = () => {
    const { limit, setPageLimit } = useUrlPagination();

    return (
        <div>
            <Select
                value={limit?.toString() || DEFAULT_PAGE_LIMIT.toString()}
                onValueChange={(value) => setPageLimit(Number(value))}
            >
                <SelectTrigger className="w-[180px]">
                    <SelectValue placeholder="Select limit" />
                </SelectTrigger>
                <SelectContent>
                    <SelectItem value="10">10 Items</SelectItem>
                    <SelectItem value="20">20 Items</SelectItem>
                    <SelectItem value="50">50 Items</SelectItem>
                    <SelectItem value="100">100 Items</SelectItem>
                    <SelectItem value="500">500 Items</SelectItem>
                </SelectContent>
            </Select>
        </div>
    );
};
